module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('gheader', {
    attrs: {
      "type": "home"
    }
  }), _vm._v(" "), _c('glogo'), _vm._v(" "), _c('grednav', {
    attrs: {
      "type": "home"
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-agreement"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    attrs: {
      "id": "agreement"
    }
  }, [_c('h2', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("供应商操作手册")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "source"
    }
  }, [_c('p')]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('h4', [_vm._v("一、城投库内供应商信息变更操作")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("城投信息门户："), _c('a', {
    attrs: {
      "href": "http://yc.yonyoucloud.com/smi/cashome.html"
    }
  }, [_vm._v("https://yc.yonyoucloud.com/smi/cashome.html")])]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("登录后选择进入工作台（推荐使用谷歌浏览器）")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_1_1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("城投库内供用商若出现企业信息变更情况，可先查看原供应商信息后，")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("点击客户管理——我的变更申请——发起变更")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_1_2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("选择对应的客户变更档案，确定")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_1_3.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("页面内容同供应商申请页面，企业唯一性字段控制不能修改，修改后信息需要在进行供应商审核后才会进入供应商档案。同时有些信息可以不需要审核直接修改，如联系人，企业简介等，直接在企业信息管理中修改即可。（红色星号"), _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※")]), _vm._v("为必填项，其他内容请根据采购商要求进行填写）")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_1_4.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("全部信息填写完毕后，下拉至页面底部，请先点击暂存后，再点击提交审核。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("提交后在客户管理——我的变更申请——待审核 内查看")]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("供应商查看审核进度：")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("①\t当状态由待审核变更为"), _c('label', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("已变更")]), _vm._v("则代表变更完成")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_1_5.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("②\t当状态由待审核变更为"), _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("已驳回/二次审核驳回")]), _vm._v("，请点击该条变更记录"), _c('label', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("查看")]), _vm._v("驳回理由，根据采购商要求"), _c('label', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("再次编辑")]), _vm._v("进行"), _c('label', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("提交")])]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_1_6.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_1_7.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("二、供应商招标")]), _vm._v(" "), _c('h5', [_vm._v("1.供应商报名")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("供应商报名分两种情况，一种是邀请报名，一种是直接报名。")]), _vm._v(" "), _c('h6', [_vm._v("1.1 邀请报名")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("直接登录账号即可，登录账户，进入工作台，投标管理，在报名中查看“待报名”的数量，点击“报名”按钮，填写相关资料报名即可。")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual12.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h6', [_vm._v("1.2 直接报名")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("在友云采招采门户，查询招标信息，点击相关招标信息，点击我要报名，然后登录后，点击报名，填写相关资料后，点击“报名”即可")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_6.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual14.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_7.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual16.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("2.供应商招标")]), _vm._v(" "), _c('h6', [_vm._v("2.1 供应商投标")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("\n            登录账号如果在招标管理，在待投标里可以看到可以投标的数量，上传附件，输入报价，点击“保存”“投标”按钮即可。采购商如果对报价不满意，可以发起谈判，然后供应商可以在“待投标”进行报价。")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual17.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual18.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual19.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("3.中标通知")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("中标后供应商账号和招标门户都会收到中标通知。")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual20.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_8.png",
      "alt": ""
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/template-compiler?{"id":"data-v-6589fefb","hasScoped":false}!./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/manual/manual.vue
// module id = 276
// module chunks = 15